export function clearCookiesExcept(whitelist: string[] = []) {
  const hostname = window.location.hostname;

  const domainCandidates: string[] = (() => {
    const parts = hostname.split('.').filter(Boolean);
    if (parts.length <= 1) return [hostname];
    const out: string[] = [];
    for (let i = 0; i < parts.length; i++) {
      out.push(parts.slice(i).join('.'));
    }
    return out;
  })();

  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [name] = cookie.split('=').map((c) => c.trim());
    if (!name) continue;

    if (!whitelist.includes(name)) {
      document.cookie = `${name}=; Max-Age=0; path=/;`;

      for (const domain of domainCandidates) {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain};`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain};`;
      }
    }
  }
}

export function setCookie(name: string, value: string, days: number) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${value}; Max-Age=${maxAge}; path=/; Secure; SameSite=Lax`;
}

export function hasCookie(name: string): boolean {
  return document.cookie
    .split(';')
    .some((c) => c.trim().startsWith(`${name}=`));
}
